import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const PendingProfExams = () => {
    const [professionalExams, setProfessionalExams] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchProfessionalExams();
    }, []);

    const fetchProfessionalExams = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/professionalExams/pending');
            const data = await response.json();
            setProfessionalExams(data);
        } catch (error) {
            console.error('Error fetching professional exams:', error);
        }
    };

    const handleDelete = async (examId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this professional exam?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/professionalExams/delete/${examId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setProfessionalExams(professionalExams.filter(exam => exam.id !== examId));
                        Swal.fire({
                            title: "Deleted!",
                            text: "The professional exam has been deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete professional exam');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the professional exam.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting professional exam:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the professional exam.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handleApprove = async (examId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to approve this professional exam?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, approve it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/professionalExams/approve/${examId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setProfessionalExams(professionalExams.filter(exam => exam.id !== examId));
                        Swal.fire({
                            title: "Approved!",
                            text: "The professional exam has been approved.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to approve professional exam');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to approve the professional exam.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error approving professional exam:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to approve the professional exam.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter professional exams based on search term
    const filteredProfExams = professionalExams.filter(exam =>
        (exam.examName && exam.examName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (exam.shortName && exam.shortName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (exam.university && exam.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (exam.instituteEmail && exam.instituteEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (exam.institutePhone && exam.institutePhone.toString().toLowerCase().includes(searchTerm.toLowerCase()))
    );

    return (
        <div>
            <AdminDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>PENDING PROFESSIONAL EXAMS</h1>
                    <form>
                        <input type="text" placeholder='Search Item' onChange={(e) => setSearchTerm(e.target.value)} />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>
                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                                <tr>
                                    <th>Exam Name</th>
                                    <th>Short Name</th>
                                    <th>By</th>
                                    <th>Start Date</th>
                                    <th>Contact No.</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredProfExams.map((exam) => (
                                <tr key={exam.id}>
                                    <td>{exam.examName}</td>
                                    <td>{exam.shortName}</td>
                                    <td>{exam.university}</td>
                                    <td>{new Date(exam.startDate).toLocaleDateString('en-CA')}</td>
                                    <td>{exam.institutePhone}</td>
                                    <td>{exam.instituteEmail}</td>
                                    <td>
                                        <a href={exam.instituteWebsite} target="_blank" rel="noopener noreferrer">
                                            Visit Website
                                        </a>
                                    </td>
                                    <td id='action-buttons'>
                                        <a href="#!" id='app-details' onClick={() => handleApprove(exam.id)}>APPROVE</a>
                                        <a href="#!" id='del-details' onClick={() => handleDelete(exam.id)}>DELETE</a>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PendingProfExams;
